/* eslint-disable */
const getters = {
  getFilters(state) {
    return state.data;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
